import ScrambleText from './ScrambleText';

export default function StatCard({ label, word, body }) {
  return (
    <div className="stat-card">
      <p className="stat-card__label"> // {label}</p>
      <h3 className="stat-card__word">
        <ScrambleText text={word} />
      </h3>
      <p className="stat-card__body">{body}</p>
    </div>
  );
}